import { memo } from 'react';
import { useLocation } from 'react-router-dom';

import { AuthHeader, AuthSider } from '@/widgets/layout';

import { ChatBot } from '@/entities/chat-bot';

import { getGoogleProcessingPath } from '@/shared/constants/router';
import { useEmbeddedMode } from '@/shared/lib/hooks';
import { Layout } from '@/shared/ui/layout';

export const AuthLayout = memo(() => {
    const { pathname } = useLocation();
    const { isEmbedded } = useEmbeddedMode();

    return (
        <>
            <Layout
                flow="auth"
                headerSlot={
                    isEmbedded ? undefined : (
                        <AuthHeader pathRoute={pathname} />
                    )
                }
                isLoading={false}
                sidebarSlot={
                    isEmbedded ? undefined : (
                        <AuthSider pathRoute={pathname} />
                    )
                }
            />
            {!isEmbedded && pathname !== getGoogleProcessingPath() && (
                <ChatBot place="auth" />
            )}
        </>
    );
});

AuthLayout.displayName = 'AuthLayout';
